import {Serializable} from "@/models/serializable";
import VueI18n  from "@/plugins/i18n";

export default class Country implements Serializable<Country> {
  name: string;
  nameIt: string;
  nameEn: string;
  iso: string;

  deserialize(input: any): Country {
    if (input != null) {
      this.nameIt = input.translations['it'];
      this.nameEn = input.name;
      this.iso = input.alpha2Code
      this.name = input.translations[VueI18n.locale] || input.name;
    }
    return this;
  }
}
